const topics = [
  { name: '明星黑历史', count: '2,186条', icon: 'ri-star-line' },
  { name: '网红翻车', count: '1,854条', icon: 'ri-live-line' },
  { name: '娱乐圈内幕', count: '1,672条', icon: 'ri-film-line' },
  { name: '商业丑闻', count: '1,503条', icon: 'ri-building-line' },
  { name: '社会热点', count: '1,391条', icon: 'ri-fire-line' },
  { name: '官场黑幕', count: '1,248条', icon: 'ri-government-line' },
  { name: '情感八卦', count: '1,105条', icon: 'ri-heart-line' },
  { name: '财务造假', count: '987条', icon: 'ri-money-dollar-circle-line' },
  { name: '食品安全', count: '856条', icon: 'ri-restaurant-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          话题分类
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {topics.map((topic, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg p-4 border border-background-200/70 text-center cursor-pointer hover:border-primary-200 hover:bg-primary-50/50 transition-colors group"
            >
              <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className={`${topic.icon} text-lg text-primary-500 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900">{topic.name}</h3>
              <p className="text-xs text-foreground-500 mt-1">{topic.count}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}